import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isUnauthorizedError } from "../utils/authErrors";

export function useSessionExpiry() {
  const navigate = useNavigate();
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const handleAuthError = useCallback((error) => {
    if (isUnauthorizedError(error)) {
      localStorage.removeItem("royal-token");
      setIsSessionExpired(true);
      return true;
    }

    console.log(error);
    return false;
  }, []);

  const confirmSessionExpired = useCallback(() => {
    setIsSessionExpired(false);
    sessionStorage.clear();
    localStorage.removeItem("royal-token");
    navigate("/");
  }, [navigate]);

  return {
    isSessionExpired,
    handleAuthError,
    confirmSessionExpired,
  };
}
